import { ESlotType } from './enums/ESlotType';

export const kindConfig: Record<ESlotType, string> = {
  [ESlotType.Supervision]: 'Супервизия',
  [ESlotType.Personal]: 'Персональная консультация',
};
